export const vsParameters =  /* glsl */`
  #include <common>
  attribute vec2 i2uv;
  uniform sampler2D uPositionsTexture;
  uniform float uTime;
  uniform float uNoiseTimeScale;
  uniform float uNoisePositionScale;
  uniform float uNoiseScale;
  uniform vec3 uOffset;
  uniform float uPersistence;
  varying vec4 vColorId;
  varying vec3 vObjectPosition;

`

export const vsTransformVertex =  /* glsl */`
  vec4 pos = texture(uPositionsTexture, i2uv);
  vec3 objectPosition = position;
  objectPosition = objectPosition; 
	objectPosition.y *= pos.y;

  vec3 transformed = objectPosition + vec3(pos.x, 0.0, pos.z);
  
  vColorId = pos;
  vObjectPosition = objectPosition;
`

export const fsParameters =  /* glsl */`
  #include <common>
  varying vec4 vColorId;
  varying vec3 vObjectPosition;
  uniform float uRandomColor;
  uniform sampler2D colorPalette;
  uniform float uTime;
  vec3 pal( in float t, in vec3 a, in vec3 b, in vec3 c, in vec3 d ) {
    return a + b*cos( 6.28318*(c*t+d) );
  }
`

export const fsTransformColor =  /* glsl */`
if(vObjectPosition.y < -1.0) discard;
vec3 color = vec3(0.56, 0.56, 0.36) * 1.5;
vec3 color2 = vec3(0.39,0.62, 0.847) * 1.5;
vec3 color3 = texture(colorPalette, vec2(0.3, uRandomColor)).rgb;

if(vObjectPosition.y > 30.0) color = mix(color, vec3(1.0), smoothstep(30.0, 60.0, vObjectPosition.y));
if(vObjectPosition.y < 1.0) color = mix(color2, color, smoothstep(0.0, 1.0, vObjectPosition.y));
diffuseColor.rgb = color;
`